import { Model } from '@vuex-orm/core';
import { PriceTypes } from '@/utils/constants';
import Price from './Price';

export default class Material extends Model {
    static entity = 'materials';

    static fields() {
        return {
            id: this.increment(),
            name: this.string(''),
            description: this.string(''),
            iconUrl: this.string(''),
            material: this.string(''),
            materialNumber: this.string('')
        }
    }

    getUnitPrice(position_id) {
        var price = Price.query().where((p) => { return p.material == this.material && p.priceType == PriceTypes.Unit && p.position_id == position_id }).first();
        if (price != null)
            return price.price;
        else
            return null;
    }

    getTotalPrice(position_id) {
        var price = Price.query().where((p) => { return p.material == this.material && p.priceType == PriceTypes.Total && p.position_id == position_id }).first();
        if (price != null)
            return price.price;
        else
            return null;
    }
}